export default {
  "content": "<path d=\"M13.533 10.557h-3.165l.62-2.806h2.68c1.096 0 1.73.5 1.73 1.326 0 .98-.769 1.48-1.865 1.48zm-1.134 5.71H9.106l.726-3.287h2.682c1.327 0 2.134.556 2.134 1.556 0 1.019-.826 1.73-2.249 1.73zm6.094-7.67c0-1.828-1.391-3.014-3.303-3.357l.332-1.582A.546.546 0 0014.988 3h-2.015c-.258 0-.48.18-.534.432l-.363 1.705H8.768a.409.409 0 00-.4.32l-2.85 12.907a.41.41 0 00.399.497h3.112l-.312 1.464a.547.547 0 00.53.66l2.018.015c.26.002.486-.18.54-.434l.357-1.705h.314c3.23 0 5.286-1.768 5.286-4.056 0-1.345-.73-2.44-1.864-2.998 1.422-.404 2.595-1.538 2.595-3.21z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};